import React from 'react';

export const MetamaskIcon = (props: React.SVGProps<SVGElement>) => {
  return (
    <svg
      className={props.className}
      onClick={props.onClick}
      width="23"
      height="22"
      viewBox="0 0 23 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_4528_10297)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.59082 20.1666L9.58115 21.0179V19.9047L9.82525 19.6428H11.534V20.9523V21.869H9.7032L7.44518 20.8214L6.59082 20.1666Z"
          fill="#CDBDB2"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.3545 20.1666L13.4252 21.0179V19.9047L13.1811 19.6428H11.4724V20.9523V21.869H13.3032L15.5611 20.8214L16.3545 20.1666Z"
          fill="#CDBDB2"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.82516 17.7441L9.58105 19.9047L9.88613 19.6428H13.0595L13.4256 19.9047L13.1815 17.7441L12.6933 17.4166L10.2523 17.4822L9.82516 17.7441Z"
          fill="#393939"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.17773 3.14282L9.64236 6.80949L10.3137 17.4822H12.6937L13.426 6.80949L14.7685 3.14282H8.17773Z"
          fill="#F89C35"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.77025 11.1965L0.0615234 16.5L4.33334 16.2381H7.07945V13.9465L6.9574 9.23218L6.34714 9.75599L1.77025 11.1965Z"
          fill="#F89D35"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.00391 11.7858L10.008 11.9167L9.45886 14.6667L7.07879 14.012L5.00391 11.7858Z"
          fill="#D87C30"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.00391 11.8512L7.07879 13.9464V16.0417L5.00391 11.8512Z"
          fill="#EA8D3A"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.0791 14.012L9.52014 14.6667L10.3135 17.4823L9.76424 17.8096L7.0791 16.1072V14.012Z"
          fill="#F89D35"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.07903 16.1072L6.59082 20.1667L9.82525 17.7441L7.07903 16.1072Z"
          fill="#EB8F35"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.0087 11.9166L10.3139 17.4822L9.39844 14.6339L10.0087 11.9166Z"
          fill="#EA8E3A"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.27148 16.1727L7.07868 16.1072L6.59047 20.1667L4.27148 16.1727Z"
          fill="#D87C30"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.40409 21.9346L6.59124 20.1667L4.27226 16.1727L0.0615234 16.5001L1.40409 21.9346Z"
          fill="#EB8F35"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.64188 6.80957L7.01782 9.16671L5.00391 11.7858L10.008 11.9822L9.64188 6.80957Z"
          fill="#E8821E"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.59082 20.1667L9.82525 17.7441L9.58115 19.8394V21.0179L7.38421 20.5596L6.59082 20.1667Z"
          fill="#DFCEC3"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.3545 20.1667L13.1811 17.7441L13.4252 19.8394V21.0179L15.6222 20.5596L16.3545 20.1667Z"
          fill="#DFCEC3"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.66557 13.0952L9.33691 14.6012L6.95685 13.9465L8.66557 13.0952Z"
          fill="#393939"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.34277 0.0655518L9.6423 6.80954L8.23876 3.14287L1.34277 0.0655518Z"
          fill="#E88F35"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.34261 0.0654297L0.244141 3.66662L0.8544 7.59519L0.427218 7.8571L1.03748 8.44638L0.54927 8.90471L1.22056 9.55948L0.793374 9.95233L1.76979 11.2619L6.34674 9.75591C8.58435 7.83527 9.68282 6.85313 9.64214 6.80948C9.60145 6.76583 6.83494 4.51781 1.34261 0.0654297Z"
          fill="#8E5A30"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M21.176 11.1965L22.8848 16.5L18.6129 16.2381H15.8668V13.9465L15.9889 9.23218L16.5991 9.75599L21.176 11.1965Z"
          fill="#F89D35"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.9414 11.7858L12.9373 11.9167L13.4865 14.6667L15.8665 14.012L17.9414 11.7858Z"
          fill="#D87C30"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.9414 11.8512L15.8665 13.9464V16.0417L17.9414 11.8512Z"
          fill="#EA8D3A"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.8672 14.012L13.4261 14.6667L12.6328 17.4823L13.182 17.8096L15.8672 16.1072V14.012Z"
          fill="#F89D35"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.8663 16.1072L16.3545 20.1667L13.1811 17.8096L15.8663 16.1072Z"
          fill="#EB8F35"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.9376 11.9166L12.6324 17.4822L13.5479 14.6339L12.9376 11.9166Z"
          fill="#EA8E3A"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.6738 16.1727L15.8666 16.1072L16.3548 20.1667L18.6738 16.1727Z"
          fill="#D87C30"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M21.5422 21.9346L16.355 20.1667L18.674 16.1727L22.8848 16.5001L21.5422 21.9346Z"
          fill="#EB8F35"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.3034 6.80957L15.9275 9.16671L17.9414 11.7858L12.9373 11.9822L13.3034 6.80957Z"
          fill="#E8821E"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.2797 13.0952L13.6084 14.6012L15.9885 13.9465L14.2797 13.0952Z"
          fill="#393939"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M21.6035 0.0655518L13.304 6.80954L14.7075 3.14287L21.6035 0.0655518Z"
          fill="#E88F35"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M21.6027 0.0654297L22.7012 3.66662L22.0909 7.59519L22.5181 7.8571L21.9078 8.44638L22.396 8.90471L21.7248 9.55948L22.1519 9.95233L21.1755 11.2619L16.5986 9.75591C14.361 7.83527 13.2625 6.85313 13.3032 6.80948C13.3439 6.76583 16.1104 4.51781 21.6027 0.0654297Z"
          fill="#8E5A30"
        />
        <g clipPath="url(#clip1_4528_10297)">
          <path
            d="M-60.7514 179.433C-14.6758 179.433 22.6758 139.33 22.6758 89.8614C22.6758 40.3924 -14.6758 0.289917 -60.7514 0.289917C-106.827 0.289917 -144.179 40.3924 -144.179 89.8614C-144.179 139.33 -106.827 179.433 -60.7514 179.433Z"
            fill="#3396FF"
            stroke="#66B1FF"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_4528_10297">
          <rect width="23" height="22" fill="white" />
        </clipPath>
        <clipPath id="clip1_4528_10297">
          <rect width="167.273" height="179.592" fill="white" transform="translate(-144.388 0.0654297)" />
        </clipPath>
      </defs>
    </svg>
  );
};
